<template>
  <div class="noticeContainer">
    <v-card-title class="d-flex align-center pe-2">
      <v-spacer></v-spacer>

      <v-text-field
          v-model="search"
          density="compact"
          label="Search"
          prepend-inner-icon="mdi-magnify"
          variant="solo-filled"
          flat
          hide-details
          single-line
      ></v-text-field>
    </v-card-title>
    <v-data-table v-model:search="search" :headers="tableHeaders" :items="noticeData" class="table" style="padding-left: 30px; padding-right: 30px;">
      <!-- eslint-disable vue/valid-v-slot -->
      <template #item.notice="{ item }">
        <v-textarea :rows="12" class="textarea" v-model="item.notice" @change="saveNotice(item.id, item.notice)"></v-textarea>
      </template>
      <!-- eslint-enable vue/valid-v-slot -->
    </v-data-table>
  </div>
</template>

<script>
import {loadWorkshop, onNoticeChange, saveNotice} from "@/workshop/workshopFunctions";
import segmentData from '../data/segment.json'

export default {
  name: "WorkshopNotice",
  components: {},
  data() {
    return {
      search: '',
      workshopData: {},
      noticeData: [],
      tableHeaders: [
        {
          title: 'Name',
          align: 'start',
          key: 'name'
        },
        {
          title: 'Category',
          align: 'start',
          key: 'category'
        },
        {
          title: 'Notice',
          align: 'start',
          key: 'notice'
        },
      ],
    }
  },
  computed: {
    workshopId() {
      return this.$route.params.id;
    },
    customerId() {
      return this.$route.params.customerId;
    },
  },
  mounted() {
    this.$store.dispatch('saveCustomerId', this.customerId);
    loadWorkshop(this.customerId, this.workshopId).then(res => {
      this.workshopData = res;
      this.load();
    });
    onNoticeChange(this.workshopId, this.noticeChange);
  },
  methods: {
    load(){
      const generalKey = 'general';
      const data = [];
      let notice = '';
      if(this.workshopData != undefined && this.workshopData.notice != undefined && Object.keys(this.workshopData.notice).includes(generalKey)){
        notice = this.workshopData.notice[generalKey];
      }
      data.push({
        id: generalKey,
        name: "General",
        category: "General",
        notice: notice
      })
      for (const cat of [...segmentData]) {
        for (const subcat of cat.children) {
          let notice = '';
          if(this.workshopData != undefined && this.workshopData.notice != undefined && Object.keys(this.workshopData.notice).includes(subcat.id)){
            notice = this.workshopData.notice[subcat.id];
          }
          data.push({
            id: subcat.id,
            name: subcat.text.en.name,
            category: cat.text.en.name,
            notice: notice
          })
        }
      }
      this.noticeData = data;
    },
    noticeChange(data){
      if(data != null){
        for(const n of Object.keys(data)){
          let notice = this.noticeData.find((item) => item.id === n);
          if(notice != undefined){
            notice.notice = data[n];
          }
        }
      }
    },
    saveNotice(id, notice){
      saveNotice(this.workshopId, id, notice);
    }
  }
}
</script>

<style>
  .noticeContainer .v-table tr th:nth-child(1),
  .noticeContainer .v-table tr td:nth-child(1) {
    width: 200px;
  }

  .noticeContainer .v-table tr th:nth-child(2),
  .noticeContainer .v-table tr td:nth-child(2) {
    width: 200px;
  }

  .noticeContainer .v-table tr th:nth-child(3),
  .noticeContainer .v-table tr td:nth-child(3) {
    width: unset;
  }
</style>